import script from "./OpenNewCard.vue?vue&type=script&setup=true&lang=js"
export * from "./OpenNewCard.vue?vue&type=script&setup=true&lang=js"

import "./OpenNewCard.vue?vue&type=style&index=0&id=56a57170&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56a57170"]])

export default __exports__